<div class="s-full pos-rel fx-row fx-align-center fx-justify-around">
  <svg
    class="pos-abs"
    width="100%"
    height="100%"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">

    <defs>
      <filter
        id="solid"
        primitiveUnits="objectBoundingBox">
        <feImage
          preserveAspectRatio="none"
          width="110%"
          height="110%"
          x="-5%"
          y="0%"
          [attr.xlink:href]="getFilterSolid()"/>
        <feComposite
          operator="over"
          in="SourceGraphic"/>
      </filter>
    </defs>

    <line
      *ngIf="!!fromSolarToHome"
      x1="25%"
      y1="50%"
      x2="75%"
      y2="50%"
      stroke="var(--yellow-200)"
      stroke-width="1px"/>

    <ng-container *ngFor="let _ of [].constructor(duration); let index = index">
      <ng-container *ngFor="let _ of [].constructor(2); let j = index">
        <ng-container *ngTemplateOutlet="path; context: getPathConfig({
            color: 'var(--orange-400)',
            size: j === 0 ? 2 : 3,
            blur: j === 0 ? false : true,
            delay: index,
            active: !!fromSolarToHome
          })">
        </ng-container>
      </ng-container>
    </ng-container>

    <ng-template
      #path
      let-blur="blur"
      let-color="color"
      let-duration="duration"
      let-delay="delay"
      let-active="active"
      let-size="size">
      <line
        x1="25%"
        y1="50%"
        x2="75%"
        y2="50%"
        stroke-linecap="round"
        stroke-dasharray=".1 100%"
        [ngClass]="{
          'blur-1': blur === true
        }"
        [attr.stroke-width]="size"
        [style.animation-iteration-count]="active ? 'infinite' : '0'"
        [style.animation-timing-function]="'linear'"
        [style.animation-name]="'dash'"
        [style.animation-duration]="duration + 's'"
        [style.animation-delay]="delay + 's'"
        [attr.stroke]="color"/>
    </ng-template>
    <!-- 50 -->
    <text
      *ngIf="!!fromSolarToHome && showPowerFlow"
      class="text-bold"
      filter="url(#solid)"
      fill='var(--grey-400)'
      dominant-baseline="middle"
      text-anchor="middle"
      x="50"
      y="50"
      [style.font-size.px]="fontSize">
      {{ fromSolarToHome | measures : valuePrecision : '' }}
    </text>
    <!-- legend -->
    <text
      class="text-bold"
      fill='var(--grey-400)'
      dominant-baseline="middle"
      text-anchor="middle"
      x="10"
      y="10"
      [style.font-size.px]="fontSize">
      {{ unitLabel }}
    </text>

    <text
      class="text-bold text-style-italic"
      fill='black'
      dominant-baseline="middle"
      text-anchor="middle"
      x="22"
      y="10"
      [style.font-size.px]="fontSize">
      {{ unitSymbol }}
    </text>
  </svg>

  <div class="s-3p fx-center rounded z-index-1 pos-rel">
    <ng-content select="[solar]"></ng-content>

  </div>
  <div class="s-3p fx-center rounded z-index-1 pos-rel">
    <ng-content select="[home]"></ng-content>
  </div>

  <div class="z-index-1 pos-abs inset-b-2 inset-r-1">
    <ng-content select="[date]"></ng-content>
  </div>
</div>
